import { config } from "_config";
import { getFileExtension } from "_helpers/parsers";

export function validatePassword(password) {
  const checkLength = new RegExp(/^.{8,}$/);
  const hasDigit = new RegExp(/^(?=.*\d).*$/);
  const hasUpperLetter = new RegExp(/^(?=.*[A-Z]).*$/);
  const hasLowerLetter = new RegExp(/^(?=.*[a-z]).*$/);
  const hasSpecialSymbol = new RegExp(/^(?=.*[!@#$%^&*])(?!.*[ ]).*$/);
  const complexCheck = new RegExp(/^[a-zA-Z0-9!@#$%^&*]+$/);

  const c1 = checkLength.test(password);
  const c2 = hasDigit.test(password);
  const c3 = hasUpperLetter.test(password);
  const c4 = hasLowerLetter.test(password);
  const c5 = hasSpecialSymbol.test(password);
  const c6 = complexCheck.test(password);

  return c1 && c2 && c3 && c4 && c5 && c6;
}

export function getFileExtensionsString(arr) {
  if (Array.isArray(arr) && !arr.includes("*")) {
    return arr.map((ext) => "." + ext).join(", ");
  }

  return "";
}

export function checkIfFileAllowed(ext, allowedExt) {
  if (!Array.isArray(allowedExt) || allowedExt === undefined || allowedExt.includes("*") || allowedExt.length === 0) {
    return true;
  }

  return allowedExt.includes(ext);
}

export function sanitizeFileName(fileName) {
  if (fileName) {
    const extension = getFileExtension(fileName, true);
    const name = fileName.slice(0, fileName.length - extension.length);
    const result = name.replace(/[^a-zA-Z0-9._-]/g, "") + extension;

    return result;
  }

  return;
}

export function validateUrl(url) {
  try {
    const validUrl = new URL(url);

    return validUrl ? true : false;
  } catch (_) {
    return false;
  }
}

export function checkIfTestCard(cardNumber) {
  const testNumbers = ["0000000000000000"];

  if (["dev", "stage"].includes(config.envName)) {
    testNumbers.push("7000000000000001");
  }

  return testNumbers.includes(cardNumber);
}

export function handleProductName(productName) {
  const result = productName?.replace("V2", "").replace("V3", "").trim();

  return result;
}

export function handleProductStatus({ status, error, logOfStatuses = [] }) {
  if (!status) return { status: "Processing", error: null };

  const specialStatuses = new Set([
    "Pending",
    "VerAFastHold",
    "AutomationFailed",
    "PendingCharge",
    "ReadyToWork",
    "ReadyToFile",
    "Claimed",
    "Lead",
  ]);

  const specialErrors = new Set([
    "MissingArticles",
    // other processingErrors...
  ]);

  if (status === "Error" && error && specialErrors.has(error)) {
    if (logOfStatuses?.length > 1) {
      for (let i = logOfStatuses.length - 2; i >= 0; i--) {
        const prevStatus = logOfStatuses[i].status;
        const prevError = logOfStatuses[i].error;

        if (!specialStatuses.has(prevStatus) && (!prevError || !specialErrors.has(prevError))) {
          return { status: prevStatus, error: prevError || null };
        }
      }
    }
    return { status: "Processing", error: null };
  }

  if (status === "Pending") {
    const lastStatusObj = logOfStatuses?.length ? logOfStatuses[logOfStatuses.length - 1] : null;
    if (lastStatusObj?.status === "Pending" && lastStatusObj?.username === "customer") {
      return { status: "Hold", error: null };
    }
  }

  if (!specialStatuses.has(status)) return { status: status, error: error || null };

  if (logOfStatuses?.length > 1) {
    for (let i = logOfStatuses.length - 2; i >= 0; i--) {
      const prevStatus = logOfStatuses[i].status;
      const prevError = logOfStatuses[i].error;
      if (!specialStatuses.has(prevStatus) && (!prevError || !specialErrors.has(prevError))) {
        return { status: prevStatus, error: prevError || null };
      }
    }
  }

  return { status: "Processing", error: null };
}

export function handleOrderNotes(notes = []) {
  const handleNoteMessage = (message) => {
    return message.replace(/Changed to .*$/, "Was Changed");
  };

  const notesForCustomer = notes.map((note) => {
    return {
      ...note,
      message: handleNoteMessage(note.message),
    };
  });

  return notesForCustomer;
}
